export enum EPlanFormat {
  PNG8 = 'png8',
  PNG24 = 'png24',
}
